module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing-diversity"
  }, [_c('hero', {
    attrs: {
      "props": _vm.pageInclusion.elements,
      "heroHome": false,
      "lightbox": true
    }
  }), _vm._v(" "), (_vm.pageInclusion.elements != undefined) ? _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-section affinity intro"
  }, [_c('div', {
    staticClass: "inside",
    domProps: {
      "innerHTML": _vm._s(_vm.pageInclusion.elements.intro_detail.value)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.pageInclusion.elements != undefined) ? _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-section affinity"
  }, [_c('div', {
    staticClass: "inside",
    domProps: {
      "innerHTML": _vm._s(_vm.pageInclusion.elements.affinity_section.value)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.pageInclusion.elements != undefined) ? _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-section goals"
  }, [_c('div', {
    staticClass: "inside",
    domProps: {
      "innerHTML": _vm._s(_vm.pageInclusion.elements.goals_intro.value)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inside table-desktop",
    domProps: {
      "innerHTML": _vm._s(_vm.pageInclusion.elements.goals_table_desktop.value)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inside table-mobile",
    domProps: {
      "innerHTML": _vm._s(_vm.pageInclusion.elements.goals_table_mobile.value)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inside",
    domProps: {
      "innerHTML": _vm._s(_vm.pageInclusion.elements.goals.value)
    }
  })]) : _vm._e(), _vm._v(" "), _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-articles insights"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('h2', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center"
  }, [_vm._v("Insights, Commentary and News")]), _vm._v(" "), _c('articles-wrapper', {
    attrs: {
      "boxes": _vm.relatedArticles,
      "isHome": true,
      "boxlimit": 4,
      "pathRoute": '/words',
      "showCategory": true,
      "showViewAll": true
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c2426a0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/Inclusion.vue
// module id = 1512
// module chunks = 0